import { gql } from "@apollo/client";

export const TicketPriceFragment = gql`
  fragment Ticket on TicketPrice {
    title
    ticketPriceFields {
      price
      groupTicketPrice {
        node {
          ... on TicketPrice {
            title
            ticketPriceFields {
              price
              ticketing {
                title
                description
                ticketureId
              }
            }
          }
        }
      }
      pricing {
        title
        description
        cta {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
      ticketing {
        title
        description
        ticketureId
        ticketingType
        membersTicketLink {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
        cta {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
    }
  }
`;